import * as React from "react";
import {Select, block} from "searchkit";
const map = require("lodash/map")


class PageSizeSelect extends Select {

  render() {
    const { mod, className, items,
      disabled, showCount, translate, countFormatter } = this.props;

    const bemBlocks = {
      container: block(mod).el
    }

    return (
      <div className={bemBlocks.container().mix(className).state({ disabled }) }>
        <div className="page-size-label">{window.Drupal.t("Show")}</div>
        <select onChange={this.onChange} value={this.getSelectedValue()}>
          {map(items, ({key, label, title, disabled, doc_count}) => {
            var text = translate(label || title || key)
            if (showCount && doc_count !== undefined) text += ` (${countFormatter(doc_count)})`
            return <option key={key} value={key} disabled={disabled}>{text}</option>
          })}
        </select>
      </div>
    )
  }
}
export default PageSizeSelect;



// WEBPACK FOOTER //
// ./src/PageSizeSelect.js